/*
 * maps leaflet
 */
import L from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';

function initMap(el) {
	var latlng = [46.2157467,2.2088258];
	var zoom = 4;

	if( $(el).is('[data-marker-lat]') && $(el).is('[data-marker-lng]') && $($(el).data('marker-lat')).val() != '' && $($(el).data('marker-lng')).val() != '' ) {
		latlng = [ parseFloat($($(el).data('marker-lat')).val()), parseFloat($($(el).data('marker-lng')).val()) ];
		zoom = 15;
	}

	var map = L.map(el).setView(latlng, zoom);
	var OpenStreetMap_BlackAndWhite2 = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	}).addTo(map);

	if( $(el).is('[data-marker]') ) {
		var marker = L.marker(latlng, {
			draggable: true
		}).addTo(map);

		if( $(el).is('[data-marker-lat]') && $(el).is('[data-marker-lng]') ) {
			marker.on('drag', function(e) {
				var location = marker.getLatLng();
				$($(el).data('marker-lat')).val(location.lat);
				$($(el).data('marker-lng')).val(location.lng);
			});
		}
	}

	if( $(el).is('[data-localize]') ) {
		const provider = new OpenStreetMapProvider();

		var $btn = $($(el).data('localize'));
		$btn.click(function() {
			var t = $btn.data('query').split('+');
			var query = [];
			for(var i = 0; i < t.length; i++)
				query.push( $(t[i]).val() );
			provider.search({ query: query.join(' ') }).then(function(result) {
				latlng = [result[0].y, result[0].x];
				map.setView(latlng, 15);
				if( $(el).is('[data-marker]') ) {
					marker.setLatLng(latlng);
				}
				if( $(el).is('[data-marker-lat]') && $(el).is('[data-marker-lng]') ) {
					$($(el).data('marker-lat')).val(result[0].y);
					$($(el).data('marker-lng')).val(result[0].x);
				}
			});
		});
	}

	// re-render les cartes si collapse
	$('.collapse').on('shown.bs.collapse', function() {
		var $this = $(this);
		if( $(el).parents('#' + $this.attr('id')).get().length )
			map.invalidateSize();
	});

}

$('.map_leaflet').each(function(i, el) {

	initMap(el);

});
